import script from "./ConfigurationList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationList.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationList.vue?vue&type=style&index=0&id=7485f55b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7485f55b"]])

export default __exports__